import { Component, input } from '@angular/core';

@Component({
	selector: 'app-final-auth-modal',
	templateUrl: './final-auth-modal.component.html',
})
export class FinalAuthModalComponent {
	email_ = input<string>('test@example.com');
}
